var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price modelArts"},[_vm._t("top"),(_vm.loading)?_c('loading',{attrs:{"size":24}}):_vm._e(),(!_vm.loading)?_c('Table',{key:Math.random(),attrs:{"columns":_vm.columns,"data":_vm.data,"height":"270"}}):_vm._e(),(!_vm.loading)?_vm._t("bottom"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }